module.exports = __webpack_public_path__ + "img/logo_live.30da95fe.png";